import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import '../../styles/header.scss';

const AdminHeader = ({company, setCompany}) => {
    const {t, i18n} = useTranslation();
    const [currentLang, setCurrentLang] = useState(i18n.resolvedLanguage);

    const [showLangs, setShowLangs] = useState(false);
    const handleLangChange = (e) =>{
        setShowLangs(false);
        const lang = e.currentTarget.dataset.lang;
        i18n.changeLanguage(lang);        
        setCurrentLang(lang);
    }

    return (
        <header id="header" className="admin">
            <div className="navbar">
                <a href="/">
                    <span className="navbar-brand">
                        <i></i>
                    </span>
                </a>
                <div className="nav">
                    <li className={`nav-item ${company === 'ragroup' ? 'active' : ''}`} onClick={(e)=>{e.preventDefault(); setCompany('ragroup')}} >
                        <div className="nav-link">RA Group</div>
                    </li>
                    <li className={`nav-item ${company === 'wave' ? 'active' : ''}`} onClick={(e)=>{e.preventDefault(); setCompany('wave')}}>
                        <div className="nav-link">Wave</div>
                    </li>
                </div>
                <div className="btns">
                    <div className={`dropdown ${showLangs ? 'active': ''}`}>
                        <a className="dropbtn" onClick={(e)=>{e.preventDefault(); setShowLangs(!showLangs)}}>{currentLang}</a>
                        <ul className="dropcontent">
                            {currentLang !== 'ru' && (<li onClick={handleLangChange} data-lang="ru">RU</li>)}
                            {currentLang !== 'en' && (<li onClick={handleLangChange} data-lang="en">EN</li>)}
                            {currentLang !== 'kz' && (<li onClick={handleLangChange} data-lang="kz">KZ</li>)}
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    )
};

export default AdminHeader;